import { getLegacyArticleBySlug } from "../../../api/articles/requests";
import { BASENAME } from "../../../router/constants";
import { getBasename } from "../../../helpers/routingHelpers";
import { useEffect, useMemo, useState } from "react";
import { getPathnameWithoutLocale } from "../../../helpers/URLHelpers";

/**
/anime-news/$YY/$MM/$DD/$slug      	/news/$category/$YY/$MM/$DD/$slug
/anime-feature/$YY/$MM/$DD/$slug  	/news/$category/$YY/$MM/$DD/$slug
/news                              	/news
/newsfeed/                        	/news
/newsfeed/archive/feature	          /news
/newsfeed/writer/$username        	/news
/newsfeed/archive/press-release	    /news
/newsfeed/tag/$tag	                /news/tag/$tag
*/
export const useMatchedLegacyRoute = () => {
  const [route, setRoute] = useState(null);
  const pathname = getPathnameWithoutLocale();
  const basename = useMemo(() => {
    let _basename = `${getBasename()}/${BASENAME}`;
    if (!_basename.startsWith("/")) _basename = `/${_basename}`;
    return _basename;
  }, []);

  useEffect(() => {
    if (/(anime-news|anime-feature)\/.+/i.test(pathname)) {
      getLegacyArticleBySlug(pathname)
        .then((data) => {
          let path = [basename, data.slug].join("/");

          setRoute(path);
        })
        .catch(() => {
          setRoute(basename);
        });
    }

    const matches = pathname.match(/newsfeed\/tag\/(.+)/i);

    if (matches) {
      setRoute(`${basename}/tag/${matches[1].replace(/(\+|%20)/g, " ")}`);
    }

    if (/newsfeed(\/archive|\/writer|\/$|$)/i.test(pathname)) {
      setRoute(basename);
    }
  }, []);

  return route;
};
